import { useMutation, useQuery, useQueryClient } from "react-query";
import { linkAPI } from "../../services/linkAPI";

import { AxiosError } from "axios";
import { LinkPlanPatch } from "../../types/link.types";
import { CallbackFunction } from "../../../../common/types/callback.types";


export interface SingleLinkPlanCore {
    planBTId?: string;
    linkId?: string;
}

export default function useSinglePlanLinkCore({planBTId, linkId}: SingleLinkPlanCore) {

    const queryClient = useQueryClient();

    const singlePlanLinkQuery = useQuery({
        queryKey: ["planLink", planBTId,linkId ],
        queryFn: () => linkAPI.getSingleLink( linkId || "", planBTId || ""),
        enabled: (planBTId && linkId) ? true : false
    })

    const updatePlanLink = useMutation({
        mutationFn: ({newLink, callback}:{newLink: LinkPlanPatch, callback: CallbackFunction}) => linkAPI.updateLinkPlan(linkId || "", newLink, planBTId || "")
        .then (res => {
            callback({result: res});
            return Promise.resolve(res);
        })
        .catch((error: AxiosError) => {
            callback({error: error});
            return Promise.reject(error);}
      ),
      
      onSuccess: () => {
        singlePlanLinkQuery.refetch();
        queryClient.invalidateQueries(["planLink", planBTId, linkId]);

      }

    })
  return {

    singlePlanLinkQuery:{
        ...singlePlanLinkQuery,
        error: singlePlanLinkQuery.error as AxiosError
    },

    updatePlanLink: {
        ...updatePlanLink,
        error: updatePlanLink.error as AxiosError
    }

  }
}
